import { createContext } from "react";
import { APP_MESSAGES, MESSAGES } from "./messages";

const MessageContext = createContext<APP_MESSAGES>(MESSAGES);

export default MessageContext;